import React from "react";
import { sortTypes } from "../constants";
import { useTasks } from "../contexts/tasks-context";
import { translate } from "@td/shared_utils";
import {
  ListViewSortButton,
} from "../components";
import { TableHeader, TableColumn } from "@td/ui";

const columns = {
  task: sortTypes.TYPE,
  category: sortTypes.CATEGORY,
  assigned_to: null,
  member: null,
  consult: null,
  due_date: sortTypes.DUE_DATE,
  priority: sortTypes.PRIORITY,
  status: sortTypes.STATUS,
};

const ListViewHeader = React.memo(() => {
  const { sortingParams, updateSortingParams } = useTasks();

  return (
    <TableHeader>
      {Object.entries(columns).map(([column, sortType]) => (
        <TableColumn key={column}>
          {sortType ? (
            <ListViewSortButton
              name={sortType}
              onClick={updateSortingParams}
              value={sortingParams}
            >
              {translate(null, "care_team_tasks.list_view.columns", column)}
            </ListViewSortButton>
          ) : (
            <React.Fragment>
              {translate(null, "care_team_tasks.list_view.columns", column)}
            </React.Fragment>
          )}
        </TableColumn>
      ))}
      <TableColumn />
    </TableHeader>
  );
});

export default ListViewHeader;
